export const shape = {
	borderRadius: 4,
};
